export default "Playable minigames are here on the website!";